import { render, staticRenderFns } from "./issueCreate.vue?vue&type=template&id=2ad3f9ae&scoped=true&"
import script from "./issueCreate.vue?vue&type=script&lang=js&"
export * from "./issueCreate.vue?vue&type=script&lang=js&"
import style0 from "./issueCreate.vue?vue&type=style&index=0&id=2ad3f9ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad3f9ae",
  null
  
)

export default component.exports